import { Cookies } from 'react-cookie';
import type { Token } from '@/interfaces/service/auth.interface';
import { ROUTES } from '@/constants/path.constants';
import { regexEmail, regexNotNumber, regexPhoneNumber } from '@/constants/regex.constants';
import { clearUserInfo, getUserInfo } from '@/utils/user.util';

const cookies = new Cookies();

export const setToken = (token: Token): void => {
  if (!token) {
    return;
  }

  const serialized = JSON.stringify(token);

  cookies.set('token', serialized, {
    path: '/',
    maxAge: 604800, // 1주일
    domain: process.env.NEXT_PUBLIC_DOMAIN,
    secure: true,
    sameSite: 'strict'
  });
};

export const setRole = (): void => {
  const userInfo = getUserInfo();
  let userRole: string | null;
  if (userInfo?.role === 'ROLE_SUPERVISOR') {
    userRole = 'SUPERVISOR';
  } else if (userInfo?.role === 'ROLE_USER') {
    userRole = 'USER';
  } else {
    return;
  }

  cookies.set('role', userRole, {
    path: '/',
    maxAge: 604800, // 1주일
    domain: process.env.NEXT_PUBLIC_DOMAIN,
    secure: true,
    sameSite: 'strict'
  });
};

export const getToken = (): Token | null => {
  const cookieValue = cookies.get('token');
  if (cookieValue) {
    return cookieValue as Token;
  }

  return null;
};

export const getRole = (): string | null => {
  const role = cookies.get('role');
  if (role) {
    return role as string;
  }
  return null;
};

export const clearToken = () => {
  localStorage.removeItem('token');
};

export const clearAuthorization = () => {
  const domain = process.env.NEXT_PUBLIC_DOMAIN;
  cookies.remove('token', {
    path: '/',
    ...(domain && domain !== '/' && !domain.includes('/') && { domain })
  });
  cookies.remove('role', {
    path: '/',
    ...(domain && domain !== '/' && !domain.includes('/') && { domain })
  });
  clearToken();
  clearUserInfo();
};

export const clearUserWhenRefeshTokenInvalid = () => {
  if (typeof window !== 'undefined') {
    clearAuthorization();
    window.location.href = ROUTES.getLogin();
  }
};

export const checkValidationEmail = (email: string | undefined) => email !== undefined && email !== null && regexEmail.test(email);

export const checkValidationPhone = (phoneNumber: string | undefined) => {
  if (phoneNumber === undefined || phoneNumber === null) {
    return false;
  }

  const regex = new RegExp(regexPhoneNumber, 'g');

  return regex.test(phoneNumber);
};

export const checkValidationOtp = (otp: string | undefined) => otp !== undefined && otp !== null && !regexNotNumber.test(otp) && otp.length === 6;
